/* eslint-disable */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const BulkUnfriendModal = ({
  selectedContactIds = [],
  onConfirm = () => {},
  onCancel = () => {},
  isProcessing = false,
}) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    if (selectedContactIds.length === 0) return;

    onConfirm();
  };

  return (
    <div
      className="modal fade"
      id="bulkUnfriendModal"
      tabIndex="-1"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          {/* ---------- HEADER ---------- */}
          <div className="modal-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  person_remove
                </span>{" "}
              </div>
              <div>
                <h3
                  className="offcanvas-title fw-bold text-white mb-0"
                  id="addMemberLabel"
                >
                  {t("Confirm Unfriend Contacts")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Unfriend Contacts")}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onCancel}
            ></button>
          </div>

          {/* ---------- BODY ---------- */}
          <div className="modal-body px-4 py-4">
            {selectedContactIds.length === 0 ? (
              <div className="text-center text-muted">
                <span className="material-symbols-outlined fs-1">info</span>
                <p className="mt-2 mb-0">{t("No contacts selected")}.</p>
              </div>
            ) : (
              <>
                <div className="text-center mb-4">
                  <div
                    className="bg-danger-subtle text-danger rounded-circle d-inline-flex align-items-center justify-content-center"
                    style={{ width: 70, height: 70 }}
                  >
                    <span className="material-symbols-outlined fs-2">
                      person_remove
                    </span>
                  </div>
                </div>

                <p className="text-center fs-5 fw-semibold">
                  {t("You are about to unfriend")}
                </p>

                <h2 className="text-center text-danger fw-bold">
                  {selectedContactIds.length} {t("Contacts")}
                </h2>

                <p className="text-center text-muted mt-3 mb-0">
                  {t("This action will remove them from your connection list.")}
                  <br />
                  {t("You may need to reconnect again manually.")}
                </p>
              </>
            )}

            {isProcessing && (
              <div className="text-center mt-4 text-danger">
                <div className="spinner-border" role="status"></div>
                <p className="mt-2 mb-0 fw-medium">
                  {t("Processing...")} {t("Please wait")}
                </p>
              </div>
            )}

            <div className="action d-flex justify-content-end pt-3 border-top mt-4">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={handleConfirm}
                disabled={isProcessing ? true : false}
                style={{
                  cursor: isProcessing ? "not-allowed" : "pointer",
                }}
              >
                {isProcessing ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Unfriending...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Unfriend Contacts")}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkUnfriendModal;
